/* eslint-disable react/no-danger */
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

/**
 * @typedef Props
 * @prop {string} [src]
 * @prop {string} [title]
 * @prop {string} [className]
 */
/**
 * @param {Props & {[x: string]: any;}} props
 */
const MotifIcon = (props) => {
  const { src = '', className = '', title = '', ...other } = props;
  const classes = classNames({
    'motif-icon': true,
    [className]: true
  });

  return (
    <span
      className={classes}
      dangerouslySetInnerHTML={{
        __html: decodeURIComponent(src.replace(/data:image\/svg\+xml,/, ''))
      }}
      title={title}
      {...other}
      data-motif-icon
    />
  );
};

MotifIcon.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string,
  title: PropTypes.string
};

export { MotifIcon };
